import { createSlice } from '@reduxjs/toolkit';
import { TIKTOK_CONTENT_TYPE } from '@views/AdminPanelView/components/AdminPanel/components/LinkInBio/components/MyPages/components/BlocksRoutes/blocks/TikTok/components/TikTokContent/utils/constants.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    isAutoUpdate: false,
    connectedTikTokUserId: null,
    contentType: TIKTOK_CONTENT_TYPE.individual,
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '3',
    view: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const tiktokSlice = createSlice({
  name: 'tiktok',
  initialState,
  reducers: {
    tiktokStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#ECECF0',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        isAutoUpdate: blockContent.isAutoUpdate ?? false,
        connectedTikTokUserId: blockContent.connectedTiktokUserId ?? null,
        contentType: blockContent.contentType ?? TIKTOK_CONTENT_TYPE.individual,
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: String(blockDesign.layout) ?? '3',
        view: blockDesign.view ?? 'feed',
      };
    },
    tiktokClear: () => initialState,

    tiktokUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    tiktokUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    tiktokUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    tiktokUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { tiktokStore, tiktokClear, tiktokUpdateIsLoading, tiktokUpdateIsActive, tiktokUpdateBlockContent, tiktokUpdateBlockDesign } = tiktokSlice.actions;

export const selectTikTokIsLoading = (state) => state.tiktok.isLoading;

export const selectTikTokId = (state) => state.tiktok.id;
export const selectTikTokUID = (state) => state.tiktok.uid;
export const selectTikTokSID = (state) => state.tiktok.sid;

export const selectTikTokBlockContent = (state) => state.tiktok.blockContent;
export const selectTikTokBlockDesign = (state) => state.tiktok.blockDesign;

export const selectTikTokItemDesign = (state) => state.tiktok.itemDesign;
export const selectTikTokContainerDesign = (state) => state.tiktok.containerDesign;

export default tiktokSlice.reducer;
